import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { CdkDrag, CdkDragMove, CdkDropList, CdkDropListGroup, moveItemInArray } from '@angular/cdk/drag-drop';
import {ViewportRuler} from "@angular/cdk/overlay";

import { Router } from '@angular/router';
import { CameraMultiService } from './CameraMultiService';
import { AbstractComponent } from '../../../../core/common/component/AbstractComponent';

import { Title } from '@angular/platform-browser';

import moment from 'moment';

import { GridsterItem, GridsterItemComponentInterface, GridType, DisplayGrid, CompactType, GridsterConfig } from 'angular-gridster2';

var componentAddress: CameraMultiComponent;

const ITEM_MIN_SIZE_COLS: number = 5;
const ITEM_MIN_SIZE_ROWS: number = 3; 
const ITEM_MAX_SIZE_COLS: number = 10;
const ITEM_MAX_SIZE_ROWS: number = 6; 
const WHILE_CLICK_TIME: number = 200; 

@Component({
  selector: 'app-camera-multi',
  templateUrl: './CameraMulti.html',
  styleUrls: ['./CameraMulti.scss'],
})
export class CameraMultiComponent extends AbstractComponent {

  
  @ViewChild('videoContainer', {static: false}) 
  public videoContainer: ElementRef;
  @ViewChild(CdkDropListGroup) 
  public listGroup: CdkDropListGroup<CdkDropList>;
  @ViewChild(CdkDropList) 
  public placeholder: CdkDropList;


  public target = null;
  public targetIndex:number;
  public source = null;
  public sourceIndex:number;
  public dragIndex:number;
  public activeContainer;
  public startTime;
  public currentTime;

  public scope = {
    items: [],
    itemWidth : 0,
    itemHeight : 0,
    gridSize : 3,
  };
  public items: Array<GridsterItem>= [];
  public isViewDeviceName = true;
  public gridIsInit: boolean = false
  public gridDataCount: number = 0;
  public gridDataId: string
  public gridDataScope = {
    mail : '',
    isInit: true,
    grid : []
  }

  static init(gridsterItem: GridsterItem, itemComponent: GridsterItemComponentInterface) : void {

    componentAddress.service.getGridData().subscribe((res:any) => {

      let existNewData: boolean = false
      let rows: number = ITEM_MIN_SIZE_ROWS;
      let cols: number = ITEM_MIN_SIZE_COLS;
      let x: number = (componentAddress.gridDataCount % 3) * ITEM_MIN_SIZE_COLS;
      let y: number = Math.floor((componentAddress.gridDataCount / 3)) * ITEM_MIN_SIZE_ROWS

      componentAddress.gridDataScope.isInit = true

      // DB上にグリッド情報が保存されているかどうか
      if (res.length <= 0) {
        existNewData = true
      } else {

        componentAddress.gridDataScope.mail = res[0].mail
        componentAddress.gridDataId = res[0].id

        // 前回の保存情報とストリーム数が合致しない場合は整列させる
        if (componentAddress.items.length != res[0].grid.length) {
          existNewData = true
        }

        // DB上に前回と同じストリームのグリッド情報が格納されていた
        if (!existNewData) {
          for (let data of res[0].grid) {
            if (gridsterItem.streamId == data.streamId) {
              rows = data.rows
              cols = data.cols
              x = data.x
              y = data.y
            }
          }
        }
      }

      // グリッドのデータを設定していく（大きさとか）
      itemComponent.$item.x = x
      itemComponent.$item.y = y
      itemComponent.$item.rows = rows
      itemComponent.$item.cols = cols
      itemComponent.$item.dragEnabled = true
      itemComponent.$item.resizeEnabled = true
      itemComponent.$item.minItemRows = ITEM_MIN_SIZE_ROWS
      itemComponent.$item.minItemCols = ITEM_MIN_SIZE_COLS
      itemComponent.$item.maxItemRows = ITEM_MAX_SIZE_ROWS
      itemComponent.$item.maxItemCols = ITEM_MAX_SIZE_COLS

      // DBセット用スコープにも上記の内容（一部）を格納していく
      componentAddress.gridDataScope.grid.push({ rows : rows, cols : cols, streamId : gridsterItem.streamId, x : x, y: y })

      // 設定済みカウント加算
      ++componentAddress.gridDataCount;

      // 最後のデータだった
      if (componentAddress.gridDataCount == componentAddress.items.length) {

        // DBへの登録が初であればメアドとDBのIDを再取得する
        if (res.length <= 0) {
          componentAddress.service.create(componentAddress.gridDataScope).subscribe((res:any) => {
              componentAddress.service.getGridData().subscribe((res:any) => {
                componentAddress.gridDataId = res[0].id
                componentAddress.gridDataScope.mail = res[0].mail
                componentAddress.gridIsInit = true
              })
          });
        } else {
          componentAddress.service.save(componentAddress.gridDataId, 
                                        componentAddress.gridDataScope).subscribe(e => {
            componentAddress.gridIsInit = true
          });
        }

        // この設定がないとどこにでも置てしまうので最後に設定しておく（最初から設定するとセル同士の陥没バグが起きる）
        itemComponent.gridster.$options.compactType = CompactType.CompactUp

        // 設定した内容を画面に反映させるため再描画的なことをする
        window.dispatchEvent(new Event('resize')); 
      }
    });
  }

  static change(gridsterItem: GridsterItem, itemComponent: GridsterItemComponentInterface) : void {

    // 初期化中（initコールバック関数）は以下の処理が動かないようにしたい
    if (!componentAddress.gridIsInit) {
      return
    }

    componentAddress.gridDataScope.isInit = false

    for (let item of componentAddress.gridDataScope.grid) {
      if (item.streamId == gridsterItem.streamId) {
        item.cols = itemComponent.$item.cols
        item.rows = itemComponent.$item.rows
        item.x = itemComponent.$item.x
        item.y = itemComponent.$item.y
      }
    }

    componentAddress.service.save(componentAddress.gridDataId, 
                                  componentAddress.gridDataScope).subscribe(e => {
    });
  }

  public options: GridsterConfig = {
    gridType: GridType.ScrollVertical,
    displayGrid: DisplayGrid.OnDragAndResize,
    compactType: CompactType.None,

    enableEmptyCellDrop: true,

    pushItems: true,
    pushDirections: { north: false, east: false, south: true, west: false },
    
    resizable: { 
      enabled: true,
      handles: {
        s: false,
        e: false, 
        n: false, 
        w: false, 
        se: true, 
        ne: false, 
        sw: false, 
        nw: false 
      }
    },

    minCols: 15,    
    minRows: 9,
    margin: 5,
    itemInitCallback: CameraMultiComponent.init,
    itemChangeCallback: CameraMultiComponent.change
  };

  /**  */
  constructor(
    private title: Title,
    private router:Router,
    private service: CameraMultiService,
    private viewportRuler: ViewportRuler) {
      super();
    this.title.setTitle('Multi View');
    componentAddress = this
  }

  public componentWillMount() {
    window.scrollTo(0, 0);
    setInterval(() => {
      this.currentTime = moment().format("MM/DD HH:mm:ss");
    }, 1000);
  }

  public toggle() {
    this.isViewDeviceName = !this.isViewDeviceName;
  }

  public componentDidMount() {
    // this.scope.itemWidth = this.videoContainer.nativeElement.offsetWidth / 3;
    // this.scope.itemHeight = this.scope.itemWidth * .75;
    // let phElement = this.placeholder.element.nativeElement;
    // phElement.style.display = 'none';
    // phElement.parentElement.removeChild(phElement);
    this.service.get().subscribe((res:any) => {

      res.sort(function(a, b) {
        if (a.dispOrder < b.dispOrder) {
          return 1;
        } else {
          return -1;
        }
      })

      let items = res;
      for (let item of items) {
        this.items.push(item)
      }
    });

  }

  /**  */
  public render() {}

  public detail(item) {
    this.router.navigate([`/camera/detail/${ item.streamId }`])
  }

  public mousedown(e) {
    this.startTime = new Date();
  }

  public mouseup(id) {
    let endTime = new Date();
    if (endTime.getTime() - this.startTime.getTime() > WHILE_CLICK_TIME) {
      return;
    }
    this.router.navigate([`/camera/detail/${ id }`])
  }

  /** ドラッグ後の動き */
  public dropListDropped(e) {
    if (!this.target) {
      return;
    }

    let phElement = this.placeholder.element.nativeElement;
    let parent = phElement.parentElement;

    phElement.style.display = 'none';

    parent.removeChild(phElement);
    parent.appendChild(phElement);
    parent.insertBefore(this.source.element.nativeElement, parent.children[this.sourceIndex]);

    this.target = null;
    this.source = null;

    if (this.sourceIndex != this.targetIndex) {

      moveItemInArray(this.scope.items, this.sourceIndex, this.targetIndex);
      sessionStorage.setItem('camera_index', JSON.stringify(this.scope.items));
    }

  }

  public dropListEnterPredicate = (drag: CdkDrag, drop: CdkDropList) => {
    if (drop == this.placeholder)
      return true;

    if (drop != this.activeContainer)
      return false;

    let phElement = this.placeholder.element.nativeElement;
    let sourceElement = drag.dropContainer.element.nativeElement;
    let dropElement = drop.element.nativeElement;

    let dragIndex = __indexOf(dropElement.parentElement.children, (this.source ? phElement : sourceElement));
    let dropIndex = __indexOf(dropElement.parentElement.children, dropElement);

    if (!this.source) {
      this.sourceIndex = dragIndex;
      this.source = drag.dropContainer;

      phElement.style.width = sourceElement.clientWidth + 'px';
      phElement.style.height = sourceElement.clientHeight + 'px';
      
      sourceElement.parentElement.removeChild(sourceElement);
    }

    this.targetIndex = dropIndex;
    this.target = drop;

    phElement.style.display = '';
    dropElement.parentElement.insertBefore(phElement, (dropIndex > dragIndex 
      ? dropElement.nextSibling : dropElement));

    this.placeholder.enter(drag, drag.element.nativeElement.offsetLeft, drag.element.nativeElement.offsetTop);
    return false;
  }

  public dragMoved(e: CdkDragMove) {
    let point = this.getPointerPositionOnPage(e.event);
    this.listGroup._items.forEach(dropList => {
      if (__isInsideDropListClientRect(dropList, point.x, point.y)) {
        this.activeContainer = dropList;
        return;
      }
    });
  }
  public getPointerPositionOnPage(event) {
    const point = __isTouchEvent(event) ? (event.touches[0] || event.changedTouches[0]) : event;
    const scrollPosition = this.viewportRuler.getViewportScrollPosition();
    return {
      x: point.pageX - scrollPosition.left,
      y: point.pageY - scrollPosition.top
    };
  }

  public gridSizeChange() {
    // this.scope.itemWidth = this.videoContainer.nativeElement.offsetWidth / this.scope.gridSize;
    // this.scope.itemHeight = this.scope.itemWidth * .75;
  }
  @HostListener('window:resize', ['$event'])
  public onResize(event) {
    this.gridSizeChange();
  }
}
// global
function __indexOf(collection, node) {
  return Array.prototype.indexOf.call(collection, node);
};

/** Determines whether an event is a touch event. */
function __isTouchEvent(event: MouseEvent | TouchEvent): event is TouchEvent {
  return event.type.startsWith('touch');
}

function __isInsideDropListClientRect(dropList: CdkDropList, x: number, y: number) {
  const {top, bottom, left, right} = dropList.element.nativeElement.getBoundingClientRect();
  return y >= top && y <= bottom && x >= left && x <= right; 
}